import BusinessInformation from "../../components/BusinessInformation";
import GeneralInformation from "../../components/GeneralInformation";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../components/ui/tabs";

function Settings() {
  return (
    <div className="flex bg-white">
      <div className="flex-1 overflow-auto">
        <Tabs
            defaultValue="general"
            className="w-full"
          >
            <TabsList className="flex w-full bg-transparent h-auto border-b-2 border-gray-200 rounded-none p-0">
                <TabsTrigger
                  value="general"
                  className="cursor-pointer border-0 data-[state=active]:border-b-2 data-[state=active]:border-blue-600 data-[state=active]:text-blue-500 data-[state=active]:shadow-none rounded-none h-10 font-medium text-gray-500"
                >
                    General
                </TabsTrigger>
                <TabsTrigger
                    value="business"
                    className="cursor-pointer border-0 data-[state=active]:border-b-2 data-[state=active]:border-blue-600 data-[state=active]:text-blue-500 data-[state=active]:shadow-none rounded-none h-10 font-medium text-gray-500"
                >
                    Business Information
                </TabsTrigger>
            </TabsList>
            <TabsContent value="general" className="mt-0 px-10 pt-10">
                <GeneralInformation />
            </TabsContent>
            <TabsContent value="business" className="mt-0 px-10 pt-10">
                <BusinessInformation />
            </TabsContent>
        </Tabs>
      </div>
    </div>
  )
}

export default Settings;